import { useReducer, useEffect } from "react";
import TextInput from "@joinTrilo/ui/atoms/TextInput";
import { StyledWrapper } from "@joinTrilo/ui/atoms/TextInput/TextInput.styled";

export type SignupStateProps = {
    new_password: string;
    firstName: string;
    lastName: string;
};

type PasswordProps = {
    updateSignup: (signupState?: SignupStateProps, error?: string) => void;
};

const minPasswordLength = 8;
const minNameLength = 2;

const INPUT_PASSWORD = "new-password";
const INPUT_NAME = "name";
const INPUT_SURNAME = "surname";

function reducer(state: any, action: any) {
    switch (action.type) {
        case "set":
            return { ...state, [action.name]: action.value };
        default:
            throw new Error();
    }
}

export const Signup = ({ updateSignup }: PasswordProps) => {
    const [state, dispatch] = useReducer(reducer, {
        new_password: "",
        firstName: "",
        lastName: "",
    });

    useEffect(() => {
        const { new_password, firstName, lastName } = state;
        console.log("[signup state]", { state });
        if (
            firstName?.length >= minNameLength &&
            lastName?.length >= minNameLength &&
            new_password.length > minPasswordLength
        ) {
            console.log("calling updateSignup with state");
            updateSignup(state);
        } else {
            console.log("calling updateSignup with undefined");
            const error =
                new_password.length <= minPasswordLength
                    ? "Password should be at least 9 characters long"
                    : "Please fill all required fields";
            updateSignup(undefined, error);
        }
    }, [state, updateSignup]);

    return (
        <>
            <StyledWrapper>
                <TextInput
                    inputStyle="regular"
                    autoComplete="new-password"
                    autoCapitalize="off"
                    label="Create a password"
                    placeholder="Create a password"
                    spellCheck={false}
                    type="password"
                    name={INPUT_PASSWORD}
                    id={INPUT_PASSWORD}
                    value={state.new_password}
                    onChange={(e) =>
                        dispatch({
                            type: "set",
                            name: "new_password",
                            value: e.target.value,
                        })
                    }
                    style={{ width: "100%" }}
                    invalid={false}
                    disabled={false}
                />
            </StyledWrapper>
            <StyledWrapper>
                <TextInput
                    inputStyle="regular"
                    autoComplete="given-name"
                    autoCapitalize="off"
                    label="First name"
                    placeholder="First name"
                    spellCheck={false}
                    type="text"
                    name={INPUT_NAME}
                    id={INPUT_NAME}
                    value={state.firstName}
                    onChange={(e) =>
                        dispatch({
                            type: "set",
                            name: "firstName",
                            value: e.target.value,
                        })
                    }
                    style={{ width: "100%" }}
                    invalid={false}
                    disabled={false}
                />
            </StyledWrapper>
            <StyledWrapper>
                <TextInput
                    inputStyle="regular"
                    autoComplete="family-name"
                    autoCapitalize="off"
                    label="Last name"
                    placeholder="Last name"
                    spellCheck={false}
                    type="text"
                    name={INPUT_SURNAME}
                    id={INPUT_SURNAME}
                    value={state.lastName}
                    onChange={(e) =>
                        dispatch({
                            type: "set",
                            name: "lastName",
                            value: e.target.value,
                        })
                    }
                    style={{ width: "100%" }}
                    invalid={false}
                    disabled={false}
                />
            </StyledWrapper>
        </>
    );
};
